import { render, staticRenderFns } from "./ItemCat.vue?vue&type=template&id=24afd125&scoped=true&"
import script from "./ItemCat.vue?vue&type=script&lang=js&"
export * from "./ItemCat.vue?vue&type=script&lang=js&"
import style0 from "./ItemCat.vue?vue&type=style&index=0&id=24afd125&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24afd125",
  null
  
)

export default component.exports